<div class="row">
  <div class="col">


    <div class="main-card mb-3 card">
      <div class="card-body">
        
        <div class="box-header text-center">
          <h3 class="box-title">SSs com Status Aberto</h3><br />
          <span  *ngIf="this.spvDetalhes?.length > 0">Selecione para editar</span>
        </div>
        

        <div class="box-body">

          <div class="box-table h400" *ngIf="this.spvDetalhes?.length > 0">

            <table>
              <thead>
                <tr>
                  <th>Nº SS</th>
                  <th>Requisitante</th>
                  <th>Data Cadastro</th>
                  <th>Ramal</th>
                  <th>{{labelCentroCusto}}</th>
                  <th>Localização</th>
                  <th>Cadastrado por</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let spv of spvDetalhes" (click)="editar(spv?.id)" class="cp">
                  <td class="text-center">{{ spv?.id | zerosEsquerda : 5}}</td>
                  <td>{{ spv?.requisitante }}</td>
                  <td class="text-center">{{ spv?.dataHoraCadastro | date:'dd/MM/yyyy' }}</td>
                  <td class="text-center">{{ spv?.contato }}</td>
                  <td class="text-center">{{ spv?.centroCusto }}</td>
                  <td>{{ spv?.localizacao }}</td>
                  <td>{{ spv?.usuarioSolicitou }}</td>
                </tr>
                <tr *ngFor="let v of this.voids">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>

          </div>

          <div class="no-results mt-5" *ngIf="this.spvDetalhes !== undefined && this.spvDetalhes?.length == 0">
            <div class="swal2-icon swal2-success swal2-animate-success-icon">
              <div class="swal2-success-circular-line-left" style="background-color: rgb(255, 255, 255);"></div>
              <span class="swal2-success-line-tip"></span><span class="swal2-success-line-long"></span>
              <div class="swal2-success-ring"></div>
              <div class="swal2-success-fix" style="background-color: rgb(255, 255, 255);"></div>
              <div class="swal2-success-circular-line-right" style="background-color: rgb(255, 255, 255);"></div>
            </div>
            <div class="results-subtitle">No momento</div>
            <div class="results-title">Nenhum SS com status aberto</div>
          </div>



        </div>

        <div class="box-footer">
          <span *ngIf="this.spvDetalhes !== undefined && this.spvDetalhes?.length > 0" class="pl-2 pt-1 pb-2">Total SSs
            :
            <b>{{ this.spvDetalhes?.length }}</b></span>
        </div>

      </div>
    </div>

  </div>
</div>